<div id="loading-container">
  <div id="loader">
    <loaders-css [loader]="'line-scale'" [scale]="1" [color]="'white'" />
    @if (text) {
      <span>{{ text | translate }}</span>
    }
  </div>
</div>
